import {
    FETCH_FLOORS_REPORT_CHART_DATA,
    FETCH_FLOORS_REPORT_CHART_DATA_FETCHING,
    FETCH_FLOORS_REPORT_CHART_DATA_FAIL,
    FETCH_FLOORS_REPORT_CHART_DATA_SUCCESS,
    FETCH_FLOORS_REPORT_ONE_YEAR_CHART_DATA_SUCCESS,
    FETCH_FLOORS_REPORT_ONE_YEAR_CHART_DATA_FAIL,
    FETCH_FLOORS_REPORT_ONE_YEAR_CHART_DATA_FETCHING,
    FETCH_FLOORS_REPORT_ONE_YEAR_CHART_DATA
} from '../../actions/ActionTypes';

const initialState = {
    floorsReportData: [],
    floorsReportDataFetching: false,
    floorsReportDataFetchFail: false,
    floorsOneYearData: []
};

//handlers
function fetchFloorsReportDataSuccess(state, action) {
    return {
        floorsReportData: action.data,
        floorsReportDataFetching: false,
        floorsReportDataFetchFail: false
    };
}

function fetchFloorsReportDataFail(state, action) {
    return {
        ...state,
        floorsReportDataFetching: false,
        floorsReportDataFetchFail: true
    };
}

function setFetchingFloorsReportData(state, action) {
    return {
        ...state,
        floorsReportDataFetching: true
    };
}

function oneYearFetchDataSuccess(state, action) {
    return {
        ...state,
        floorsOneYearData: action.data,
        floorsReportDataFetching: false,
        floorsReportDataFetchFail: false
    };
}

const handlers = {
    [FETCH_FLOORS_REPORT_CHART_DATA_SUCCESS]: fetchFloorsReportDataSuccess,
    [FETCH_FLOORS_REPORT_CHART_DATA_FAIL]: fetchFloorsReportDataFail,
    [FETCH_FLOORS_REPORT_CHART_DATA_FETCHING]: setFetchingFloorsReportData,
    [FETCH_FLOORS_REPORT_ONE_YEAR_CHART_DATA_FETCHING]: setFetchingFloorsReportData,
    [FETCH_FLOORS_REPORT_ONE_YEAR_CHART_DATA_FAIL]: fetchFloorsReportDataFail,
    [FETCH_FLOORS_REPORT_ONE_YEAR_CHART_DATA_SUCCESS]: oneYearFetchDataSuccess
};

export default function floorsReportData(state = initialState, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// action
export function fetchFloorsReportData(startDate, endDate) {
    return {
        type: FETCH_FLOORS_REPORT_CHART_DATA,
        startDate: startDate,
        endDate: endDate
    };
}

export function fetchOneYearFloorsReportData(endDate, numWeeks) {
    return {
        type: FETCH_FLOORS_REPORT_ONE_YEAR_CHART_DATA,
        endDate: endDate,
        numWeeks: numWeeks
    };
}

// get functions
export function fetchFloorsReportDataFailed(state) {
    return state.floorsReportData.floorsReportDataFetchFail;
}

export function floorsReportDataFetching(state) {
    return state.floorsReportData.floorsReportDataFetching;
}

export function getFloorsReportData(state) {
    return state.floorsReportData.floorsReportData;
}

export function getOneYearData(state) {
    return state.floorsReportData.floorsOneYearData;
}
